// 着信モーダル（「電話を受ける」＝要望#213 AC-4/5・設計v2 §v2-1）。
// トリガは CallDock（完了 push の SW relay＝主 / SSE final＝副 / VS job-event＝将来）。

import { useCallStore, startCall, dismissIncoming, type IncomingCallInfo } from './call-store';

export function IncomingCall({ onAccepted }: { onAccepted: (info: IncomingCallInfo) => void }) {
  const incoming = useCallStore((s) => s.incoming);
  if (!incoming) return null;

  const accept = () => {
    const info = incoming;
    dismissIncoming();
    onAccepted(info);
    void startCall(info.conversationId);
  };

  return (
    <div style={S.backdrop} data-testid="incoming-call">
      <div style={S.card} className="k-card">
        <div style={S.ring}>📞</div>
        <div style={S.title}>AI から折り返しです</div>
        <div style={S.sub}>{incoming.title ?? '作業が完了しました'}</div>
        <div style={S.conv} title={incoming.conversationId}>
          会話: {incoming.conversationId.slice(0, 24)}…
        </div>
        <div style={S.actions}>
          <button type="button" style={S.accept} onClick={accept} data-testid="incoming-accept">
            受ける
          </button>
          <button type="button" className="btn-ghost" onClick={dismissIncoming} data-testid="incoming-dismiss">
            閉じる
          </button>
        </div>
      </div>
    </div>
  );
}

const S: Record<string, React.CSSProperties> = {
  backdrop: {
    position: 'fixed', inset: 0, background: 'rgba(15,23,42,0.55)', zIndex: 70,
    display: 'flex', alignItems: 'center', justifyContent: 'center',
  },
  card: { width: 320, textAlign: 'center', padding: 24, display: 'flex', flexDirection: 'column', gap: 8, alignItems: 'center' },
  ring: { fontSize: 40, animation: 'koneccoBlink 1s step-end infinite' },
  title: { fontWeight: 700, fontSize: 16 },
  sub: { color: '#475569' },
  conv: { color: '#94a3b8', fontSize: 11 },
  actions: { display: 'flex', gap: 12, marginTop: 8 },
  accept: {
    background: '#16a34a', color: '#fff', border: 'none', borderRadius: 8,
    padding: '8px 20px', fontWeight: 700, cursor: 'pointer',
  },
};
